export default "/CRAB.42c532f0daa750f1de0eec4ddba187f6.svg";